var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTrack(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 82,
    viewBox: "0 0 95 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.165 72.071h-7.807a1 1 0 01-1-1V43.447m53.394 28.624H36.78m26.972 0h4.954m-4.954 0V52.255m0-16.514V21.328a1 1 0 00-1-1H11.358a1 1 0 00-1 1v10.56m53.394 3.853H76.55a1 1 0 01.707.293l16.221 16.22M63.752 35.742v16.514m29.725 0V71.07a1 1 0 01-1 1h-6.706m7.706-19.816H63.752M10.358 31.888h20.917m-20.917 0H4.853m5.505 0v11.56m0 0H1m9.358 0h18.165",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.972,
    cy: 72.071,
    r: 8.257,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.515,
    cy: 72.071,
    r: 8.257,
    stroke: "#504FE9",
    strokeWidth: 2
  })));
}
export default SvgTrack;